export default __webpack_public_path__ + "static/media/profile-jason.fc3ac5a0.png";